import { render } from "./multi-radioboxes.html?vue&type=template&id=0a1b84f8&scoped=true&ts=true&external"
import script from "./multi-radioboxes.ts?vue&type=script&lang=ts&external"
export * from "./multi-radioboxes.ts?vue&type=script&lang=ts&external"

import "./multi-radioboxes.scss?vue&type=style&index=0&id=0a1b84f8&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1b84f8"]])

export default __exports__